import { render, staticRenderFns } from "./ChangeSubscriptionPeriod.vue?vue&type=template&id=234182ed&scoped=true"
import script from "./ChangeSubscriptionPeriod.vue?vue&type=script&lang=js"
export * from "./ChangeSubscriptionPeriod.vue?vue&type=script&lang=js"
import style0 from "./ChangeSubscriptionPeriod.vue?vue&type=style&index=0&id=234182ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234182ed",
  null
  
)

export default component.exports